import { bytesToNDigits } from '@mail/cross-sizes-utils';
import { isNil } from 'ramda';
import React, { memo } from 'react';
import type { SizeProps } from 'reactApp/ui/DataListItemRow/DataListItemRow.types';

import styles from '../DataListItemRow.css';

export const Size = memo(function Size({ size }: SizeProps) {
    return <div className={styles.size}>{!isNil(size) && bytesToNDigits(size, 3).value}</div>;
});
